<template>
  <div
    :style="{
      width: '100%',
      height: `${screeHeight}px`,
      overflow: 'hidden',
      backgroundImage: 'url(' + (bgContent ? bgContent : '') + ')',
      backgroundSize: '100% 100%',
    }"
  >
    <div style="overflow-y: auto; height: 100%">
      <div
        v-if="levelData.type == 'livesFrameList'"
        style="
          position: relative;
          display: flex;
          flex-wrap: wrap;
          padding-top: 10px;
          justify-content: center;
        "
      >
        <img
          :key="key"
          @click="goToDetail('live', childItem.id)"
          v-for="(childItem, key) in levelData.list"
          :src="childItem.cover"
          :style="{
            border:
              levelData.showBorder == 2
                ? '2px solid #FFF'
                : levelData.showBorder == 1
                ? '2px solid #000'
                : '0px',
            width: 'calc(50% - 20px)',
            marginLeft: key % 2 == 1 ? '10px' : '0px',
            marginBottom: '10px',
            height: '98px',
          }"
        />
      </div>
      <div
        v-if="levelData.type == 'videosFrameList'"
        :style="{
          display: 'flex',
          'justify-content': 'center',
          'align-items': 'center',
        }"
      >
        <videosItem
          :newsList="levelData.list"
          :showBorder="levelData.showBorder"
        />
      </div>
      <div v-if="levelData.type == 'newsFrameList'">
        <newsItem
          :newsList="levelData.list"
          :showBorder="levelData.showBorder"
        />
      </div>
    </div>
  </div>
</template>
<script>
import newsItem from "@/components/subject/news";
import videosItem from "@/components/subject/videos";
import { getResourceSubjectsDetail } from "@/utils/request.js";
export default {
  components: {
    newsItem,
    videosItem,
  },
  data() {
    return {
      subjectId: "",
      subjectLeveLId: "",
      screeHeight: "",
      bgContent: "",
      levelData: {},
    };
  },
  created() {
  },
  mounted() {
    this.screeHeight = document.documentElement.clientHeight;
    console.log(this.$route.path);
    let path = this.$route.path.split("/");
    let len = path.length;
    this.subjectId = path[len - 2];
    this.subjectLeveLId = path[len - 1];
    console.log("levelId:" , this.subjectId, this.subjectLeveLId);
    this.querySubjectInfo(this.subjectId);
  },
  methods: {
    // 查询专题
    querySubjectInfo() {
      getResourceSubjectsDetail(this.subjectId).then((res) => {
        if(!res || !res.data){
            console.log('专题查询失败')
            return
        }
        let content = JSON.parse(res.data.content);
        content.frameContent.forEach((element) => {
          if (element.type == "bcImage") {
            this.bgContent = element.src;
          }
        });
        this.levelData = content.frameContent[this.subjectLeveLId - 1];
        console.log(this.levelData);
      });
    },
    goToDetail(type, id) {
      if (type == "live") {
        this.$router.push({ path: `/live/player/${id}` });
      }
    },
  },
};
</script>
<style lang="less" scoped>
</style>